import React from 'react';
import { HeaderText } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';

export default UI(HeaderText)();
